import { groupAccountMapColumns } from '../../../../../backend/features/groups/shared';
import { getGroupStorageReadonly } from '../../../../../backend/features/groups/utils/getGroupStorageReadonly';
import { flatten } from '../../../../../backend/utils/FilterUtils';
import { authGroup } from '../Group/Callbacks/OnAuth';
export const groupAccountMapEntity = {
    version: 3,
    columns: groupAccountMapColumns,
    onMigrate: (params) => params.oldData,
    onTransformColumns: (context, params) => {
        return {
            groupId: params.data.groupId,
            accountId: params.data.accountId,
            unique: [params.data.groupId, params.data.accountId].filter((id) => !!id).join('_'),
        };
    },
    // Managing this entity from Frontend is disabled, use addAccountsToGroup bulk action
    onAuthPost: (appState, userState, params) => {
        if (!(params.action === 'create' && params.massCreate)) {
            // non mass-create actions are not allowed, mass actions authorised in their callbacks
            throw new Error('Unauthorised');
        }
    },
    onAuthGet: () => {
        throw new Error('Unauthorised');
    },
    onAuthList: () => {
        throw new Error('Unauthorised');
    },
    onAuthMassCreate: (appState, userState, params, context) => {
        const groupStorage = getGroupStorageReadonly(context);
        const groupIds = new Set(params.items.map((item) => item.data.groupId));
        const groups = groupStorage.list({
            filter: [
                {
                    id: Array.from(groupIds),
                    op: 'in',
                },
            ],
        });
        for (const group of groups.rows) {
            authGroup(userState, group);
        }
    },
    onAuthMassDelete: (appState, userState, params, context) => {
        const groupStorage = getGroupStorageReadonly(context);
        const flatFilter = flatten(params.filter);
        const groupIds = new Set();
        for (const filter of flatFilter) {
            if ('column' in filter && 'value' in filter && filter.column === 'groupId') {
                if (Array.isArray(filter.value)) {
                    filter.value.forEach(groupIds.add);
                }
                else {
                    groupIds.add(filter.value);
                }
            }
        }
        const groups = groupStorage.list({
            filter: [
                {
                    id: Array.from(groupIds),
                    op: 'in',
                },
            ],
        });
        for (const group of groups.rows) {
            authGroup(userState, group);
        }
    },
};
